import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { Link } from 'react-router-dom';

export default function Home() {
  const services = [
    {
      icon: 'ri-battery-charge-line',
      title: 'Battery Diagnostics',
      description: 'Advanced battery health analysis and diagnostics to optimize your EV\'s performance and range.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20EV%20mechanic%20performing%20electric%20vehicle%20battery%20diagnostics%20with%20modern%20computer%20equipment%20in%20a%20clean%2C%20well-lit%20garage%20workshop%20with%20EV%20charging%20stations%20and%20diagnostic%20machines%20visible%20in%20the%20background%2C%20realistic%20photography%20style&width=400&height=300&seq=1&orientation=landscape'
    },
    {
      icon: 'ri-charging-pile-2-line',
      title: 'Charging System Repair',
      description: 'Complete charging system inspection, repair, and installation for optimal charging performance.',
      image: 'https://readdy.ai/api/search-image?query=Skilled%20EV%20technician%20working%20on%20electric%20vehicle%20charging%20system%20repair%2C%20showing%20charging%20ports%20and%20electrical%20components%20in%20a%20professional%20automotive%20service%20center%20with%20clean%20workspace%20and%20proper%20lighting&width=400&height=300&seq=2&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electric Motor Service',
      description: 'Expert electric motor diagnostics, maintenance, and repair for all EV motor types.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electric%20motor%20service%20being%20performed%20by%20experienced%20EV%20mechanic%20in%20modern%20automotive%20garage%20with%20clean%20equipment%20and%20proper%20safety%20procedures&width=400&height=300&seq=3&orientation=landscape'
    },
    {
      icon: 'ri-cpu-line',
      title: 'Software Updates',
      description: 'EV software diagnostics, updates, and programming for optimal vehicle performance.',
      image: 'https://readdy.ai/api/search-image?query=Expert%20EV%20technician%20performing%20software%20updates%20and%20diagnostics%20on%20electric%20vehicle%20computer%20systems%20in%20professional%20automotive%20workshop%20with%20specialized%20tools%20and%20clean%20working%20environment&width=400&height=300&seq=4&orientation=landscape'
    },
    {
      icon: 'ri-plug-line',
      title: 'Electrical Systems',
      description: 'Comprehensive high-voltage electrical system diagnostics and repair for all EV components.',
      image: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20electrical%20system%20repair%20being%20performed%20by%20skilled%20technician%20using%20specialized%20EV%20diagnostic%20equipment%20in%20modern%20car%20service%20center%20with%20proper%20safety%20protocols&width=400&height=300&seq=5&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Preventive Maintenance',
      description: 'Regular EV maintenance including brake service, tire rotation, and system inspections.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20EV%20preventive%20maintenance%20service%20being%20performed%20in%20clean%20automotive%20service%20bay%20with%20modern%20equipment%20and%20tools%20specifically%20designed%20for%20electric%20vehicles&width=400&height=300&seq=6&orientation=landscape'
    }
  ];

  const testimonials = [
    {
      name: 'Sarah Johnson',
      rating: 5,
      comment: 'Excellent EV service! They diagnosed my Tesla\'s battery issue quickly and fixed it at a fair price. Highly recommend DJT EV Mechanic for reliable electric vehicle repair.',
      location: 'Tesla Owner'
    },
    {
      name: 'Mike Rodriguez',
      rating: 5,
      comment: 'Been bringing my fleet of electric delivery vehicles here for 2 years. Always professional, knowledgeable about EVs, and gets the job done right.',
      location: 'Fleet Manager'
    },
    {
      name: 'Emily Chen',
      rating: 5,
      comment: 'Great customer service and transparent pricing. They explained my Nissan Leaf\'s charging system repair clearly and completed it ahead of schedule.',
      location: 'EV Enthusiast'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=Modern%20professional%20electric%20vehicle%20repair%20garage%20workshop%20with%20EV%20charging%20stations%2C%20clean%20organized%20workspace%2C%20advanced%20diagnostic%20equipment%2C%20electric%20car%20lifts%2C%20and%20bright%20lighting%2C%20creating%20a%20trustworthy%20and%20eco-friendly%20atmosphere%20for%20electric%20vehicle%20maintenance%20and%20repair%20services&width=1920&height=1080&seq=7&orientation=landscape')`
        }}
      >
        {/* Enhanced Road Animation Section */}
        <div className="absolute top-16 left-0 w-full h-20 pointer-events-none overflow-visible z-10">
          {/* Road Surface */}
          <div className="absolute top-0 left-0 w-full h-10 bg-gradient-to-b from-gray-700 via-gray-800 to-gray-900 shadow-2xl border-b-2 border-gray-600">
            {/* Road Surface Texture */}
            <div className="absolute inset-0 bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800"></div>
            
            {/* Complete Dashed Center Lines - Full Width Coverage */}
            <div className="absolute top-1/2 left-0 w-full h-0.5 transform -translate-y-1/2 flex">
              {Array.from({ length: 50 }, (_, i) => (
                <div key={i} className="flex">
                  <div className="w-8 h-full bg-white opacity-90 shadow-sm"></div>
                  <div className="w-4 h-full bg-transparent"></div>
                </div>
              ))}
            </div>
            
            {/* Road Edge Lines */}
            <div className="absolute top-1 left-0 w-full h-0.5 bg-white/80 shadow-sm"></div>
            <div className="absolute bottom-1 left-0 w-full h-0.5 bg-white/80 shadow-sm"></div>
          </div>

          {/* Enhanced City Skyline Background */}
          <div className="absolute top-10 left-0 w-full h-10 pointer-events-none z-5">
            <div className="absolute bottom-0 left-16 w-12 h-8 bg-gradient-to-t from-gray-600/40 to-gray-500/30 rounded-t-lg shadow-lg"></div>
            <div className="absolute bottom-0 left-32 w-10 h-6 bg-gradient-to-t from-gray-600/35 to-gray-500/25 rounded-t-md shadow-md"></div>
            <div className="absolute bottom-0 left-48 w-14 h-10 bg-gradient-to-t from-gray-600/45 to-gray-500/35 rounded-t-xl shadow-xl"></div>
            <div className="absolute bottom-0 left-72 w-10 h-8 bg-gradient-to-t from-gray-600/40 to-gray-500/30 rounded-t-lg shadow-lg"></div>
            
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-16 h-12 bg-gradient-to-t from-gray-600/50 to-gray-500/40 rounded-t-2xl shadow-2xl"></div>
            
            <div className="absolute bottom-0 right-16 w-12 h-8 bg-gradient-to-t from-gray-600/40 to-gray-500/30 rounded-t-lg shadow-lg"></div>
            <div className="absolute bottom-0 right-32 w-10 h-8 bg-gradient-to-t from-gray-600/35 to-gray-500/25 rounded-t-md shadow-md"></div>
            <div className="absolute bottom-0 right-48 w-10 h-6 bg-gradient-to-t from-gray-600/30 to-gray-500/20 rounded-t-sm shadow-sm"></div>
          </div>

          {/* Electric Car Animation - Enhanced positioning on dashed center line */}
          <div className="absolute top-0 left-0 w-full h-20 pointer-events-none z-20">
            <div className="relative w-full h-full overflow-visible">
              <div className="absolute top-2 animate-ev-story z-25">
                <div className="relative flex items-end">
                  <div className="relative w-20 h-12">
                    <img 
                      src="https://static.readdy.ai/image/b8a021112837a070edfa44e380da93b7/d035007d92d879cac85a1565af668226.png"
                      alt="Electric Vehicle"
                      className="w-full h-full object-contain filter drop-shadow-2xl brightness-110"
                    />
                    
                    {/* Enhanced glow effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-400/30 via-cyan-400/30 to-emerald-400/30 rounded-full blur-lg animate-pulse opacity-70" style={{ animationDuration: '3s' }}></div>
                    
                    {/* Energy Trail Effect */}
                    <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-6">
                      <div className="w-3 h-0.5 bg-blue-400/80 rounded-full animate-pulse shadow-lg" style={{ animationDelay: '0s' }}></div>
                      <div className="absolute top-0.5 left-0.5 w-1.5 h-1.5 bg-orange-400 rounded-full animate-ping shadow-md" style={{ animationDelay: '0.3s' }}></div>
                      <div className="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-red-400 rounded-full animate-ping shadow-md" style={{ animationDelay: '0.6s' }}></div>
                      <div className="absolute bottom-0.5 left-0.5 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-ping shadow-md" style={{ animationDelay: '0.9s' }}></div>
                    </div>
                    
                    {/* Breakdown Warning Indicator */}
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-red-500 rounded-full animate-ping breakdown-indicator shadow-lg"></div>
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-red-600 rounded-full breakdown-indicator flex items-center justify-center shadow-xl">
                      <div className="w-0.5 h-0.5 bg-white rounded-full"></div>
                    </div>
                  </div>

                  {/* Vehicle Shadow - Enhanced and positioned on road surface */}
                  <div className="absolute bottom-0 left-0 w-20 h-1.5 bg-black/40 rounded-full blur-sm"></div>
                </div>
              </div>

              {/* Mechanic on Bike Animation - Enhanced positioning on road surface */}
              <div className="absolute top-0 animate-mechanic-story z-25">
                <div className="relative flex items-end">
                  <div className="relative w-20 h-16">
                    {/* Bike Frame */}
                    <div className="absolute bottom-2 left-1 w-16 h-8">
                      <div className="absolute bottom-3 left-1 w-12 h-0.5 bg-gray-700 rounded-lg transform rotate-12 shadow-md"></div>
                      <div className="absolute bottom-3 left-3 w-10 h-0.5 bg-gray-700 rounded-lg transform -rotate-12 shadow-md"></div>
                      <div className="absolute bottom-3 left-6 w-0.5 h-6 bg-gray-700 rounded-lg shadow-md"></div>
                      
                      {/* Handlebars */}
                      <div className="absolute bottom-8 left-6 w-5 h-0.5 bg-gray-600 rounded-lg shadow-sm"></div>
                      <div className="absolute bottom-8 left-5 w-0.5 h-3 bg-gray-600 rounded-lg shadow-sm"></div>
                      <div className="absolute bottom-8 right-5 w-0.5 h-3 bg-gray-600 rounded-lg shadow-sm"></div>
                    </div>
                    
                    {/* Bike Wheels - Positioned on road surface */}
                    <div className="absolute bottom-2 left-1 w-5 h-5 bg-gray-800 rounded-full border border-gray-600 animate-spin shadow-lg" style={{ animationDuration: '0.5s' }}>
                      <div className="absolute inset-0.5 bg-gray-700 rounded-full"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-0.5 bg-gray-400 rounded-full"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-0.5 bg-gray-400 rounded-full rotate-90"></div>
                    </div>
                    <div className="absolute bottom-2 right-1 w-5 h-5 bg-gray-800 rounded-full border border-gray-600 animate-spin shadow-lg" style={{ animationDuration: '0.5s' }}>
                      <div className="absolute inset-0.5 bg-gray-700 rounded-full"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-0.5 bg-gray-400 rounded-full"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-0.5 bg-gray-400 rounded-full rotate-90"></div>
                    </div>

                    {/* Mechanic Image */}
                    <div className="absolute bottom-7 left-6 w-10 h-12">
                      <img 
                        src="https://static.readdy.ai/image/b8a021112837a070edfa44e380da93b7/51b0f412f47ad220cd41492e11b1f533.png"
                        alt="EV Mechanic"
                        className="w-full h-full object-contain filter drop-shadow-2xl animate-bounce-slow"
                      />
                      
                      {/* Enhanced glow effect around mechanic */}
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-400/30 via-cyan-400/30 to-emerald-400/30 rounded-full blur-lg animate-pulse opacity-70" style={{ animationDuration: '3s' }}></div>
                    </div>
                    
                    {/* Shadow - Enhanced and positioned on road surface */}
                    <div className="absolute bottom-2 left-0 w-20 h-1.5 bg-black/40 rounded-full blur-sm"></div>
                  </div>
                </div>
              </div>

              {/* Repair Tools & Sparks Animation - Positioned on center line */}
              <div className="absolute top-2 animate-tools-story z-30">
                {/* Tools */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-5 h-3 bg-gradient-to-r from-gray-600 to-gray-800 rounded-lg shadow-lg"></div>
                <div className="absolute left-1/2 transform -translate-x-1/2 translate-x-2 w-3 h-4 bg-gray-700 rounded-lg shadow-md"></div>
                
                {/* Sparks */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-3">
                  <div className="w-2 h-2 bg-yellow-400 rounded-full animate-ping shadow-lg" style={{ animationDelay: '0s' }}></div>
                  <div className="absolute top-0.5 left-0.5 w-1.5 h-1.5 bg-orange-400 rounded-full animate-ping shadow-md" style={{ animationDelay: '0.3s' }}></div>
                  <div className="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-red-400 rounded-full animate-ping shadow-md" style={{ animationDelay: '0.6s' }}></div>
                  <div className="absolute bottom-0.5 left-0.5 w-1.5 h-1.5 bg-yellow-300 rounded-full animate-ping shadow-md" style={{ animationDelay: '0.9s' }}></div>
                </div>
              </div>

              {/* Success Indicator - Positioned on center line */}
              <div className="absolute top-0 animate-success-story z-30">
                <div className="absolute left-1/2 transform -translate-x-1/2 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center shadow-2xl border-2 border-white">
                  <i className="ri-check-line text-white text-xl font-bold"></i>
                </div>
                
                {/* Success Glow */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-12 h-12 bg-green-400/40 rounded-full blur-xl animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-white">
              <h1 className="text-4xl md:text-6xl font-bold mb-6">
                Professional Electric Vehicle Repair Services
              </h1>
              <p className="text-xl md:text-2xl mb-8">
                Expert electric vehicle repair and maintenance with over 10 years of EV experience. 
                Reliable, eco-friendly, and affordable solutions for all your electric vehicle needs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/appointment" 
                  className="bg-primary-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Book EV Service
                </Link>
                <a 
                  href="tel:18005700229" 
                  className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Call 1-800-570-0229
                </a>
              </div>
            </div>

            {/* Right Animated GIF Section */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative w-96 h-96 md:w-[500px] md:h-[500px]">
                {/* Main GIF Image with enhanced container */}
                <div className="relative w-full h-full flex items-center justify-center">
                  <div className="relative animate-float">
                    <img 
                      src="https://static.readdy.ai/image/b8a021112837a070edfa44e380da93b7/7f59d613549373c90fe58a428c7aee17.png"
                      alt="EV Mechanic Working Animation"
                      className="w-80 h-80 md:w-96 md:h-96 object-contain transform hover:scale-110 transition-all duration-700 filter drop-shadow-2xl"
                    />
                    
                    {/* Enhanced glowing backdrop */}
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-400/30 via-purple-400/30 to-green-400/30 rounded-full blur-3xl animate-pulse opacity-60" style={{ animationDuration: '4s' }}></div>
                  </div>
                </div>

                {/* Orbiting Tech Icons - Enhanced with better positioning */}
                <div className="absolute inset-0">
                  {/* Primary orbit */}
                  <div className="absolute inset-0 animate-spin" style={{ animationDuration: '20s' }}>
                    <div className="relative w-full h-full">
                      <div className="absolute top-8 left-1/2 transform -translate-x-1/2">
                        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-full flex items-center justify-center shadow-2xl hover:scale-125 transition-transform duration-300 border-2 border-white/20">
                          <i className="ri-tools-line text-white text-2xl"></i>
                        </div>
                      </div>
                      
                      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
                        <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-400 rounded-full flex items-center justify-center shadow-2xl hover:scale-125 transition-transform duration-300 border-2 border-white/20">
                          <i className="ri-leaf-line text-white text-xl"></i>
                        </div>
                      </div>
                      
                      <div className="absolute top-1/2 left-8 transform -translate-y-1/2">
                        <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-400 rounded-full flex items-center justify-center shadow-2xl hover:scale-125 transition-transform duration-300 border-2 border-white/20">
                          <i className="ri-cpu-line text-white text-lg"></i>
                        </div>
                      </div>
                      
                      <div className="absolute top-1/2 right-8 transform -translate-y-1/2">
                        <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-orange-400 rounded-full flex items-center justify-center shadow-2xl hover:scale-125 transition-transform duration-300 border-2 border-white/20">
                          <i className="ri-battery-charge-line text-white text-lg"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Secondary orbit - counter rotation */}
                  <div className="absolute inset-8 animate-spin" style={{ animationDuration: '15s', animationDirection: 'reverse' }}>
                    <div className="relative w-full h-full">
                      <div className="absolute top-4 right-4">
                        <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-pink-400 rounded-full flex items-center justify-center shadow-xl hover:scale-125 transition-transform duration-300 border border-white/30">
                          <i className="ri-flashlight-line text-white text-sm"></i>
                        </div>
                      </div>
                      
                      <div className="absolute bottom-4 left-4">
                        <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-400 rounded-full flex items-center justify-center shadow-xl hover:scale-125 transition-transform duration-300 border border-white/30">
                          <i className="ri-settings-3-line text-white text-sm"></i>
                        </div>
                      </div>
                      
                      <div className="absolute top-4 left-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-cyan-400 rounded-full flex items-center justify-center shadow-xl hover:scale-125 transition-transform duration-300 border border-white/30">
                          <i className="ri-plug-line text-white text-xs"></i>
                        </div>
                      </div>
                      
                      <div className="absolute bottom-4 right-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-lime-500 to-green-400 rounded-full flex items-center justify-center shadow-xl hover:scale-125 transition-transform duration-300 border border-white/30">
                          <i className="ri-charging-pile-2-line text-white text-xs"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Enhanced Energy Rings */}
                <div className="absolute inset-0">
                  <div className="absolute inset-4 border-2 border-blue-400/40 rounded-full animate-pulse" style={{ animationDuration: '3s' }}></div>
                  <div className="absolute inset-8 border-2 border-green-400/30 rounded-full animate-pulse" style={{ animationDuration: '4s', animationDelay: '1s' }}></div>
                  <div className="absolute inset-12 border border-purple-400/20 rounded-full animate-pulse" style={{ animationDuration: '5s', animationDelay: '2s' }}></div>
                </div>

                {/* Floating Energy Particles - Enhanced */}
                <div className="absolute inset-0 pointer-events-none">
                  {/* Large particles */}
                  <div className="absolute top-16 right-20 w-3 h-3 bg-cyan-400 rounded-full animate-ping opacity-70" style={{ animationDelay: '0s', animationDuration: '2s' }}></div>
                  <div className="absolute bottom-20 left-16 w-4 h-4 bg-yellow-400 rounded-full animate-ping opacity-70" style={{ animationDelay: '1s', animationDuration: '2.5s' }}></div>
                  <div className="absolute top-32 left-20 w-2 h-2 bg-green-400 rounded-full animate-ping opacity-70" style={{ animationDelay: '2s', animationDuration: '3s' }}></div>
                  <div className="absolute bottom-32 right-24 w-5 h-5 bg-purple-400 rounded-full animate-ping opacity-70" style={{ animationDelay: '0.5s', animationDuration: '2.2s' }}></div>
                  
                  {/* Small particles */}
                  <div className="absolute top-24 right-32 w-1.5 h-1.5 bg-pink-400 rounded-full animate-ping opacity-60" style={{ animationDelay: '1.5s', animationDuration: '1.8s' }}></div>
                  <div className="absolute bottom-28 left-32 w-1 h-1 bg-blue-400 rounded-full animate-ping opacity-60" style={{ animationDelay: '2.5s', animationDuration: '2.8s' }}></div>
                  <div className="absolute top-40 left-12 w-2 h-2 bg-orange-400 rounded-full animate-ping opacity-60" style={{ animationDelay: '0.8s', animationDuration: '2.3s' }}></div>
                  <div className="absolute bottom-40 right-12 w-1.5 h-1.5 bg-teal-400 rounded-full animate-ping opacity-60" style={{ animationDelay: '1.8s', animationDuration: '2.7s' }}></div>
                </div>

                {/* Lightning Effects - Enhanced */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-20 right-28 animate-ping opacity-80" style={{ animationDelay: '0.7s', animationDuration: '3s' }}>
                    <div className="w-0.5 h-12 bg-gradient-to-b from-yellow-300 to-transparent transform rotate-12 shadow-lg"></div>
                  </div>
                  <div className="absolute bottom-24 left-28 animate-ping opacity-80" style={{ animationDelay: '2.3s', animationDuration: '3.5s' }}>
                    <div className="w-0.5 h-10 bg-gradient-to-b from-cyan-300 to-transparent transform -rotate-45 shadow-lg"></div>
                  </div>
                  <div className="absolute top-36 right-16 animate-ping opacity-80" style={{ animationDelay: '1.2s', animationDuration: '2.8s' }}>
                    <div className="w-0.5 h-8 bg-gradient-to-b from-purple-300 to-transparent transform rotate-45 shadow-lg"></div>
                  </div>
                </div>

                {/* Ambient Glow Effects */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-12 left-12 w-24 h-24 bg-blue-400/10 rounded-full blur-2xl animate-pulse" style={{ animationDuration: '6s' }}></div>
                  <div className="absolute bottom-12 right-12 w-32 h-32 bg-green-400/10 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '7s', animationDelay: '1s' }}></div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-purple-400/8 rounded-full blur-3xl animate-pulse" style={{ animationDuration: '8s', animationDelay: '2s' }}></div>
                </div>

                {/* Rotating Gradient Ring */}
                <div className="absolute inset-0 animate-spin pointer-events-none" style={{ animationDuration: '25s' }}>
                  <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-blue-400/20 to-transparent"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Expert EV Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From battery diagnostics to charging system repairs, we provide comprehensive electric vehicle services 
              to keep your EV running efficiently and sustainably.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mr-4">
                      <i className={`${service.icon} text-2xl text-primary-600`}></i>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">{service.title}</h3>
                  </div>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tools & Equipment Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-green-600 mb-6">
              Professional EV Tools & Equipment
            </h2>
            <p className="text-xl text-black max-w-3xl mx-auto">
              We use state-of-the-art diagnostic tools and specialized equipment to ensure your electric vehicle receives the highest quality service and maintenance.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {/* Diagnostic Scanner */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-computer-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">EV Scanner</h3>
              <p className="text-sm text-black">Advanced diagnostic computer for electric vehicle systems</p>
            </div>

            {/* Multimeter */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-dashboard-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Multimeter</h3>
              <p className="text-sm text-black">High-voltage digital multimeter for electrical testing</p>
            </div>

            {/* Battery Tester */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-battery-charge-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Battery Tester</h3>
              <p className="text-sm text-black">Specialized EV battery health analyzer</p>
            </div>

            {/* Oscilloscope */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-pulse-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Oscilloscope</h3>
              <p className="text-sm text-black">Digital oscilloscope for signal analysis</p>
            </div>

            {/* Insulation Tester */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Insulation Tester</h3>
              <p className="text-sm text-black">High-voltage insulation resistance tester</p>
            </div>

            {/* Charging Station Tester */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-plug-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Charging Tester</h3>
              <p className="text-sm text-black">EV charging port and cable analyzer</p>
            </div>

            {/* Torque Wrench */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-tools-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Torque Wrench</h3>
              <p className="text-sm text-black">Precision torque wrench for EV components</p>
            </div>

            {/* Thermal Camera */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-camera-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Thermal Camera</h3>
              <p className="text-sm text-black">Infrared thermal imaging for heat detection</p>
            </div>

            {/* Safety Equipment */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-shield-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Safety Gear</h3>
              <p className="text-sm text-black">High-voltage safety equipment and PPE</p>
            </div>

            {/* Lift Equipment */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-truck-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Vehicle Lift</h3>
              <p className="text-sm text-black">Professional automotive lift system</p>
            </div>

            {/* Software Tools */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-code-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Software Tools</h3>
              <p className="text-sm text-black">EV programming and calibration software</p>
            </div>

            {/* Precision Tools */}
            <div className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-settings-line text-2xl text-green-600"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Precision Tools</h3>
              <p className="text-sm text-black">Specialized EV repair and maintenance tools</p>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-lg text-black mb-6">
              Our investment in professional-grade equipment ensures accurate diagnostics and reliable repairs for your electric vehicle.
            </p>
            <Link 
              to="/appointment" 
              className="bg-green-600 text-white px-8 py-3 rounded-md text-lg font-medium hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Schedule Service Today
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Why Choose DJT EV Mechanic?
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">10+ Years EV Experience</h3>
                    <p className="text-gray-600">Our certified EV technicians have extensive experience with all electric vehicle makes and models.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Eco-Friendly & Sustainable</h3>
                    <p className="text-gray-600">We support green transportation with environmentally conscious repair practices.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Advanced EV Equipment</h3>
                    <p className="text-gray-600">State-of-the-art EV diagnostic tools and high-voltage safety equipment.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0 mt-1">
                    <i className="ri-check-line text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">EV Warranty Protection</h3>
                    <p className="text-gray-600">All our EV repairs come with comprehensive warranty coverage for your peace of mind.</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20EV%20technician%20using%20advanced%20electric%20vehicle%20diagnostic%20computer%20equipment%20in%20modern%20clean%20garage%20workshop%2C%20showing%20expertise%20and%20modern%20technology%20in%20electric%20car%20repair%20services&width=600&height=500&seq=8&orientation=landscape"
                alt="Professional EV mechanic using diagnostic equipment"
                className="w-full h-auto rounded-lg shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What Our EV Customers Say
            </h2>
            <p className="text-xl text-gray-600">
              Don't just take our word for it - hear from our satisfied electric vehicle owners
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 mb-4 italic">"{testimonial.comment}"</p>
                <div>
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Service Your Electric Vehicle?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-2xl mx-auto">
            Schedule your EV service appointment today and experience the difference of professional, 
            reliable electric vehicle maintenance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/appointment" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book EV Service
            </Link>
            <a 
              href="tel:18005700229" 
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Call 1-800-570-0229
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}